import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  ButtonGroup,
  Theme,
  useMediaQuery,
} from '@material-ui/core';

import {
  FormatListNumbered as FormatListNumberedIcon,
  Print as PrintIcon,
} from '@material-ui/icons';

import { makeStyles } from '@material-ui/core/styles';
import styles from './ResultDetailsFooter.styles';
import {
  FormInfo,
  ResultDetailsDispatchFunc,
  ResultDetailsInfo,
  ResultInfo,
} from '../types';
import config from '../../../../config';

const useStyles = makeStyles(styles);

type Props = {
  resultDetails?: ResultDetailsInfo;
  groupSelected: FormInfo;
  openTestListPopup: ResultDetailsDispatchFunc<unknown>;
};

const ResultDetailsFooter: React.FC<Props> = ({
  resultDetails,
  groupSelected,
  openTestListPopup,
}: Props) => {
  const classes = useStyles();
  const isMediumScreen = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));
  const [langIndex, setLangIndex] = useState('');

  const groupTest = resultDetails?.resultInfo.filter(
    (value: ResultInfo) => value.form.formCode === groupSelected.formCode,
  );

  const groupParams = groupTest?.flatMap((value) => value.params);
  const paramList = groupParams || [];

  function changeLangIndex(index: string) {
    localStorage.setItem(`site-${config.siteId}-lang_index`, index);
    setLangIndex(index);
  }

  useEffect(() => {
    const langCheck = localStorage.getItem(`site-${config.siteId}-lang_index`);

    if (langCheck === null) {
      localStorage.setItem(`site-${config.siteId}-lang_index`, '1');
      setLangIndex('1');
    } else {
      setLangIndex(langCheck);
    }
  }, [langIndex]);

  return (
    <Box className={classes.root}>
      <Button
        color="primary"
        classes={{ root: classes.actionButton }}
        variant="contained"
        size="large"
        onClick={() => openTestListPopup()}
      >
        <FormatListNumberedIcon style={{ paddingRight: 8 }} />
        {isMediumScreen && ('Test list')}
      </Button>

      <Box className={classes.printBox}>
        <ButtonGroup
          size="large"
          style={{ marginRight: 8 }}
          disabled={paramList.length === 0}
        >
          <Button
            key="en"
            color="primary"
            variant={langIndex === '0' ? 'contained' : 'outlined'}
            onClick={() => changeLangIndex('0')}
          >
            Eng
          </Button>
          <Button
            key="th"
            color="primary"
            variant={langIndex === '1' ? 'contained' : 'outlined'}
            onClick={() => changeLangIndex('1')}
          >
            Thai
          </Button>
        </ButtonGroup>
        <Button
          color="primary"
          classes={{ root: classes.actionButton }}
          variant="contained"
          size="large"
          onClick={() => {
            const url = [
              // mode
              'result',
              // requestId
              `${atob(resultDetails?.requestInfo.id || '').split('|')[2]}`,
              // formId
              `${groupSelected.formId}`,
              // lang
              langIndex,
            ];

            const hash = `resultPreview?action=${btoa(url.join('&'))}`;

            window.open(hash);
          }}
          disabled={paramList.length === 0}
        >
          <PrintIcon classes={{ root: classes.buttonIcons }} />
          {isMediumScreen && ('Preview')}
        </Button>
      </Box>
    </Box>
  );
};

export default ResultDetailsFooter;
